import {getCurrentInstance} from 'vue'

export default function __(key) {
    const root = getCurrentInstance().appContext

    if (root?._translations && root?._translations[key]) {
        return root._translations[key];
    }

    return key;
}

export function themeVar(varName) {
    return getComputedStyle(document.documentElement)
        .getPropertyValue('--player-' + varName);
}

export function brightnessByColor(color) {
    const isHEX = color.indexOf("#") == 0
    const isRGB = color.indexOf("rgb") == 0

    let r = undefined
    let g = undefined
    let b = undefined

    if (isHEX) {
        const hasFullSpec = color.length == 7
        const m = color.substr(1).match(hasFullSpec ? /(\S{2})/g : /(\S{1})/g)
        if (m) {
            r = parseInt(m[0] + (hasFullSpec ? "" : m[0]), 16)
            g = parseInt(m[1] + (hasFullSpec ? "" : m[1]), 16)
            b = parseInt(m[2] + (hasFullSpec ? "" : m[2]), 16)
        }
    }
    if (isRGB) {
        const m = color.match(/(\d+){3}/g)
        if (m) {
            r = m[0]
            g = m[1]
            b = m[2]
        }
    }
    if (typeof r != "undefined") return (r * 299 + g * 587 + b * 114) / 1000
}
